import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const NAVBAR_OFFSET = 80;
const MAX_RETRIES = 15;
const RETRY_INTERVAL = 100;

export default function ScrollToHash() {
  const location = useLocation();

  const scrollToElement = useCallback((id: string) => {
    const element = document.getElementById(id);
    if (!element) return false;
    const top = element.getBoundingClientRect().top + window.scrollY - NAVBAR_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
    return true;
  }, []);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0 });
      return;
    }

    const id = location.hash.replace('#', '');
    let attempts = 0;

    // Try immediately first
    if (scrollToElement(id)) return;

    const timer = window.setInterval(() => {
      attempts++;
      if (scrollToElement(id) || attempts >= MAX_RETRIES) {
        window.clearInterval(timer);
      }
    }, RETRY_INTERVAL);

    return () => window.clearInterval(timer);
  }, [location, scrollToElement]);

  return null;
}